export enum ExportType {
  Pdf = 'pdf',
  Html = 'html',
  Csv = 'csv',
  Xaf = 'xaf',
  Xlsx = 'xlsx',
  RegnskabBasis = 'regnskabBasis',
}
